var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c(
        "div",
        { staticClass: "form" },
        [
          _c("mnrcv-acno", {
            ref: "mnrcvAcno",
            attrs: {
              inAcnKnd: "1",
              inAcnDtlKnd: "2",
              value: _vm.account,
              obaobDstcd: "1",
              page: "transfer"
            },
            on: {
              "update:value": function($event) {
                _vm.account = $event
              }
            }
          })
        ],
        1
      ),
      _c("modal-pop", {
        staticClass: "modal",
        attrs: { opened: _vm.openedError, confirm: "MCOM-0000003" },
        on: {
          "update:opened": function($event) {
            _vm.openedError = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [_vm._v(_vm._s(_vm.errMsg))]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }